import {createApp} from 'vue'
import ProjectsList from './ProjectsList'

const el = '.kb-component--projects-list'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((ProjectsListDOM)=>{
            const props = {
                guid: ProjectsListDOM.dataset.guid,
                firstPageSize: parseInt(ProjectsListDOM.dataset.firstPageSize) ?? 20,
                showMorePageSize: parseInt(ProjectsListDOM.dataset.showMorePageSize) ?? 20,
                hideNoResults: ProjectsListDOM.dataset.hideNoResults === 'true',
                hideTotalCount: ProjectsListDOM.dataset.hideTotalCount === 'true'
            }

            const component = createApp(ProjectsList, props).use(Store)
            component.mount(ProjectsListDOM)
        })
    }
}